import { Vue, Component, Prop } from 'vue-property-decorator';
import Socket from '@/library/socket';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService';

@Component
export default class ExportFile extends Vue {
  // 是否是按钮模式
  @Prop({ default: false })
    isButton: boolean;

  // 导出调用的地址
  @Prop()
    serviceUrl: string;

  // 接口的参数
  @Prop({ default: () => {} })
    params: ItemObject;

  @Prop({ default: 'post' })
    httpType: 'post' | 'get';

  // 导出的文字
  @Prop({ default: '导出' })
    exportText: string;

  // 导出状态
  exportStatus = 0;

  // 导出的url
  exportUrl = '';

  get exportBtnText() {
    if (this.exportStatus === 0) {
      return this.exportText || '导出';
    }

    if (this.exportStatus === 1) {
      return '文件生成中...';
    }

    if (this.exportStatus === 2) {
      return '下载';
    }
  }

  onExport() {
    this.exportStatus = 1;
    const downloadState = +localStorage.getItem('downloadState');
    if (downloadState === 1) {
      new Socket(this.serviceUrl, this.params, this.httpType).getDownUrl().then((res) => {
        this.exportUrl = res;
        this.exportStatus = 2;
      });
    }
    if (downloadState === 2) {
      new Socket(this.serviceUrl, this.params, this.httpType).getDownUrl().then((res) => {
        if (res) {
          this.exportStatus = 0;
        }
      });
    }
  }

  onBtnClick() {
    if (this.exportStatus === 0) {
      this.onExport();
    }
    if (this.exportStatus === 2) {
      this.onDownLoad();
    }
  }

  onDownLoad() {
    Socket.download(this.exportUrl);
    this.exportStatus = 0;
  }

  // 供外部清除状态
  reset() {
    this.exportStatus = 0;
    this.exportUrl = '';
  }

  render(h) {
    return this.isButton ? (
      <el-button size="medium" type={this.exportStatus === 1 ? 'info' : 'primary'} on-click={() => this.onBtnClick()} disabled={this.exportStatus === 1}>
        {this.exportBtnText}
      </el-button>
    ) : (
      <span on-click={() => this.onBtnClick()} class={['scopeSpan', this.exportStatus === 1 && 'disabled']}>
        {this.exportBtnText}
      </span>
    );
  }
}
